const UpdateStorageModal = ({
    showUpdateModal,
    setShowUpdateModal,
    handleUpdateStorage,
  }) => {
    if (!showUpdateModal) return null;
  
    return (
      <div className="fixed inset-0 bg-black/50 bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full">
          <div className="p-6">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-blue-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                Update Required
              </h2>
              <p className="text-gray-600">
                It's time to update your browser storage. Click the button
                below to clear all local storage and cookies, then continue
                browsing.
              </p>
            </div>
  
            <div className="flex gap-3">
              <button
                onClick={handleUpdateStorage}
                className="flex-1 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default UpdateStorageModal;